import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useEffect, useCallback, useContext } from 'react';
import "../index.css";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { ProductContext } from "../context/AppContext";
import Footer from './Common_Components/Footer';
function FlashFinish() {
    const [activePage, setActivePage] = useState("");
    const location = useLocation();
    const navigate = useNavigate();
    // const { categoryId, dayId, is_review, examId } = routes.params;
    const { Translate } = useContext(ProductContext);
    const FlashFinish = location.state;
    const categoryId = FlashFinish?.categoryId;
    const methodType = FlashFinish?.methodType;
    const dayId = FlashFinish?.dayId;
    const is_review = FlashFinish?.is_review;
    const examId = FlashFinish?.examId;
    const examTypes = FlashFinish?.examTypes;
    const selectedExamId = FlashFinish?.selectedExamId;
    const LearningId = FlashFinish?.LearningId;
    const screenTitleId = FlashFinish?.screenTitleId;
    const unique_day_id = FlashFinish?.unique_day_id || dayId;
    const baseUrl = process.env.REACT_APP_BASE_URL || "https://api.japaking.online";
    console.log("LearningId Finish Flash", LearningId)
    const filteredExamType = examTypes?.filter(exam => exam.exam_type === "N4");
    console.log("examId Flash Finish:", categoryId, dayId, is_review, examId, examTypes, filteredExamType);
    const onBackPress = useCallback(() => {
        navigate("/");
    }, [navigate]);

    useEffect(() => {
        const handlePopState = (event) => {
            event.preventDefault();
            onBackPress();
        };

        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [onBackPress]);
    const [selectedLanguage, setSelectedLanguage] = useState('');
    const SelectLanguageLocal = localStorage.getItem("selectedLanguage");

    console.log(SelectLanguageLocal, "SelectLanguageLocal")
    useEffect(() => {
        const loadLanguage = async () => {
            try {
                const storedLanguage = localStorage.getItem("selectedLanguage");
                console.log("storedLanguage", storedLanguage);
                if (storedLanguage) {
                    setSelectedLanguage(storedLanguage);
                }
            } catch (error) {
                console.error("Error loading language:", error);
            }
        };

        loadLanguage();
    }, []);

    const handleNext = async () => {
        try {
            const token = localStorage.getItem("AuthToken");
            if (token && categoryId && LearningId && screenTitleId && unique_day_id && examId) {
                const response = await fetch(`${baseUrl}/api/user-visits/finish-visit`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        id: unique_day_id || dayId,
                        unique_day_id: unique_day_id || dayId,
                        learning_method_id: LearningId,
                        screen_title_id: screenTitleId,
                        examId,
                    }),
                });
                if (!response.ok) {
                    console.error("Failed to finish visit:", response.status);
                }
            }
        } catch (error) {
            console.error("Error posting finish-visit:", error);
        }

        navigate("/new-learning-journey", {
            state: {
                selectedExamId,
                examId,
                examTypes,
            },
        });
    };

    return (
        <div className='Profile_Design_Main_Div_11'>
            <div className='header_inner'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                             <ArrowBackIosIcon onClick={() => navigate('/new-learning-journey', { state: { selectedExamId: selectedExamId || examId, examId, examTypes } })} className='icon_1' />
                            <h2></h2>  {/* Display the selected day */}
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="thank-you-quiz-container">
                <div className="thank-you-content">
                    <h3>やったー！</h3>

                    <h2>{Translate?.message?.data?.youveCompletedTheQuiz || "You've Completed the Quiz!"}</h2>

                    <img
                        src={`${process.env.PUBLIC_URL}/assets/images/finishquiz.png`}

                        className="thank-you-quiz-img"
                    />

                    <div className="thank-you-quiz-button-group">
                        <button
                            className="thank-you-quiz-button"
                            onClick={handleNext}
                        >
                            {Translate?.message?.data?.next || "Next"}
                        </button>
                    </div>
                </div>
            </div>

            {/* Footer Section */}
            <Footer />
        </div>
    );
}

export default FlashFinish;
